/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    color: '#000000',
    fontName: 'StagSans',
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 1.33333333333
  }
}
export default theme
